import React, { FC } from 'react'
import { Link } from '@mui/material'
import { makeStyles } from 'tss-react/mui'

import { FileWithLatestStatus } from 'src/Libs/installation-statement/models'

interface FileLinkProps {
  data: FileWithLatestStatus | undefined
  onClick: () => void
  text: string
  disabled?: boolean
}

const useStyles = makeStyles()(() => ({
  link: {
    textDecoration: 'none',
    cursor: 'pointer',
  },
}))

const FileLink: FC<FileLinkProps> = ({ data, onClick, text, disabled }) => {
  const { classes } = useStyles()

  return (
    <Link
      className={classes.link}
      sx={theme => ({
        color: `${!disabled ? theme.palette.primary.main : theme.palette.grey.grey05} !important`,
      })}
      onClick={onClick}
    >
      {text}
    </Link>
  )
}

export default FileLink
